import * as React from 'react';

import classNames from 'classnames';

import { IContentWrapperProps } from './types';

import * as s from './ContentWrapper.scss';

interface IContentWrapperState {
}

export class ContentWrapper extends React.PureComponent<IContentWrapperProps, IContentWrapperState> {

	state: IContentWrapperState = {
		isLoading: true,
	};

	render() {
		const {
			className,
			collapseTopPadding,
			collapseBottomPadding,
			collapseLeftPadding,
			collapseRightPadding,
			collapseVerticalPadding,
			collapseHorizontalPadding,
		} = this.props;
		const classNameSum = {
			[s.collapseTopPadding]: collapseTopPadding,
			[s.collapseBottomPadding]: collapseBottomPadding,
			[s.collapseLeftPadding]: collapseLeftPadding,
			[s.collapseRightPadding]: collapseRightPadding,
			[s.collapseVerticalPadding]: collapseVerticalPadding,
			[s.collapseHorizontalPadding]: collapseHorizontalPadding,
		};

		return (
			<section className={classNames(
				s.block,
				className,
				classNameSum,
			)}>
				{this.props.children}
			</section>
		);
	}

}
